export default {
  user: {
    profile: 'Info Pessoais',
    identification: 'Identificação',
    bankCard: 'Cartão bancário',
    deposit: 'Depositar',
    withdraw: 'Retirada',
  },
};
